import * as React from 'react';
import { Box, Typography, useTheme }  from '@mui/material';
import { Result } from '../utlis/computeRemaining';
import { v4 as uuidv4 } from 'uuid';

import './animation.css'

interface IOutputFieldProps {
  data: Result;
  bylaw: string;
}
const OutputField: React.FC<IOutputFieldProps> = (props: IOutputFieldProps) => {
  const { data, bylaw } = props;

  const dataToShow = data.possibleCombinations.filter((combination)=> combination.lectures !== -1 || combination.tutorials !== -1 );

  const theme = useTheme();

  const getCurrentState = () => {
    if (data.firstWarning === 1 ) return "First Warning";
    if (data.secondWarning === 1 ) return "Second Warning";
    if (data.deprivedFlag === 1 ) return <span style={{color:'red'}}>Deprived, Please Contact the Administration ASAP</span>;
    else return "No Warnings";
  }
    
  return (
    <Box 
      sx={{
        display:'flex', 
        flexDirection: 'column',
        background: bylaw === 'Old' ? theme.palette.common.oldBylawColor : theme.palette.common.newBylawColor,
        borderRadius: '10px',
        boxSizing: 'border-box',
        padding: '20px 25px',
        gap: '5px 0px',
        width:'500px',
        height: 'fit-content',
        '@media screen and (max-width: 768px)': { flex: 1 }
      }}
    >    
      <Typography sx={{fontSize:'20px', fontWeight:'500'}}>
        {
          data.type === 'normal' ? 
            'You can miss by maximum, one of the following options:' 
            : data.type === '4crds' ? 
              'Sorry, 4-credit hours courses are not supported.' : 'Graduation projects and industrial training courses has no absence.'
        }
      </Typography>

      <Box
        sx={{
          display:'flex',
          flexDirection:'column',
          gap:'5px 0px'
        }}
      >
        {
          dataToShow.map((combination, index)=>{
            return(
              <Box
                key={uuidv4()}
                className={"verticalwipe linearWipe"} // Add the "verticalwipe" class here
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0px 20px',
                  height: '40px',
                  background: index % 2 === 0 ? theme.palette.common.evenOtputCard : theme.palette.common.oddOutputCard,
                  borderRadius: '5px',
                  transition: 'opacity 0.5s ease',
                  WebkitTransition: 'opacity 0.5s ease',
                  animation: 'verticalwipe 0.5s ease', 
                  WebkitAnimation: 'verticalwipe 0.5s ease'
                }}>
                <Typography className='linearWipe' sx={{fontSize:'18px', fontWeight:'500'}}>

                  {combination.lectures} Lectures {combination.tutorials !== -1 ? "and " + combination.tutorials + " Tutorials" : ""}
                </Typography>
              </Box>
            )
          })
        }
      </Box>
      <Typography 
        sx={{
          fontWeight: 500,
          transition: 'opacity 0.5s ease',
          WebkitTransition: 'opacity 0.5s ease',
          animation: 'verticalwipe 0.5s ease',
          WebkitAnimation: 'verticalwipe 0.5s ease'

        }}>
        { dataToShow.length !== 0 || data.deprivedFlag === 1 ? <span>Current State:&nbsp;{getCurrentState()}</span>  : ""}
      </Typography>
  
    </Box>
  );
}
export default OutputField;